import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-seo-description',
  templateUrl: './seo-description.component.html',
  styleUrls: ['./seo-description.component.css']
})
export class SeoDescriptionComponent implements OnInit {

  @Input("seoDescriptionInput") seoDescription;

  constructor() { }

  ngOnInit() {
  }

}
